import { media } from "./media";
import { ctas } from "./ctas";
import { metaInformation } from "./metaInformation";
import { KontentFilterable } from "./filterable";
import { richText } from "./richText";
import { sectionMetaData } from "./GeneralPage/generalSection";

export type accordion = {
  title: string;
  subtitle: string;
  body: richText;
  asset: media;
  cta: ctas;
} & metaInformation<"accordion"> &
  sectionMetaData &
  KontentFilterable;

export function isAccordion(item: any): item is accordion {
  return item?.type === "accordion";
}
